import type { ReactNode } from "react";
import type { Situation } from "../settings/types";
import { InPlaceProvider } from "./InPlace";
import { AnonymousProvider } from "./mode";
import { SituationProvider } from "./situation";

/**
 * CE QUE L'ÉDITEUR PARTAGE AVEC LE SITE QU'IL MONTRE, posé une fois autour des deux :
 * « Vu par » (`mode.ts`), la situation de la confirmation (`situation.tsx`) et les
 * textes que l'écran sait modifier sur place (`InPlace.tsx`). Une seule enveloppe dans
 * `Shell.tsx` plutôt que trois imbriquées.
 */
export function OrganiserViews({
  anonymous,
  situation,
  setSituation,
  children,
}: {
  anonymous: boolean;
  situation: Situation | null;
  setSituation: (situation: Situation) => void;
  children: ReactNode;
}) {
  return (
    <AnonymousProvider value={anonymous}>
      <SituationProvider value={{ situation, setSituation }}>
        <InPlaceProvider>{children}</InPlaceProvider>
      </SituationProvider>
    </AnonymousProvider>
  );
}
